ready().then(function() {

    const headerFunctions = () => {
        const header = document.querySelector('header');

        if(typeof(header) != 'undefined' && header != null) {
            /*
            *  Fire some events
            */
            window.addEventListener('scroll', calcScrollPos, false);
            window.addEventListener('load', calcScrollPos, false);

            // Recalculate header height on resize?
            //window.addEventListener('resize', addMainStartPos, false);
          

            /*
            *  Calc the scroll position on the page
            */
            function calcScrollPos() {
                const scrollPos = document.documentElement.scrollTop || window.scrollY; // scrollY needed for Safari

                if(scrollPos >= 5) {
                    // set a general header state scroll after a minor scroll
                    header.setAttribute('data-header-state', 'scroll');
                }
                if (scrollPos < 5) {
                    // and put it back when almost on top
                    header.setAttribute('data-header-state', 'default');
                }
            }

            /*
            *  We like to have a state on the mobile searchbar - so we can target some CSS-classes
            */
            function addStateToHeaderElements() {
                const header = $('header');
                const searchContainer = $('.search-bar-container');
                const headerContainerFirst = $('.header-container-first');
                const searchIconContainer = $('.icon-search');
                const navContainer = $('.nav-container');
                const logoContainer = $('.logo-container');
                const autocompleteContainer = $('.autocomplete-container');
                const headerNavAnchors = $('header .nav-anchors-container');
                const mainNavAnchors = $('main .nav-anchors-container');
                const mainSectionNavAnchors = $('main .section-nav-anchors');
                const navItems = $("section[data-nav-title]:not([data-nav-title=''])");
                const mediaBreakPointMaxXxs = window.matchMedia('(max-width:' + maxXxs + 'px)'); // slightly below Xs-width

                /**
                 * Run a callback after the user scrolls, calculating the distance and direction scroll
                 */
                var scrollDistance = function (callback, refresh) {

                    // Make sure a valid callback was provided
                    if (!callback || typeof callback !== 'function') return;

                    // Variables
                    var isScrolling, start, end, distance;

                    // Listen for scroll events
                    window.addEventListener('scroll', function (e) {

                        // Set starting position
                        if (!start) {
                            start = window.pageYOffset;
                        }

                        // Clear our timeout throughout the scroll
                        window.clearTimeout(isScrolling);

                        // Set a timeout to run after scrolling ends
                        isScrolling = setTimeout(function() {

                            // Calculate distance
                            end = window.pageYOffset;
                            distance = end - start;

                            // Run the callback
                            callback(distance, start, end);

                            // Reset calculations
                            start = null;
                            end = null;
                            distance = null;

                        }, refresh || 66);

                    }, false);

                };

                scrollDistance(function (distance) {
                    if(distance <= -150) { // if we scroll more then 150px up
                        // scroll up

                        // first check if the searchresult list - autocomplete is open - don't change state when open
                        if (! autocompleteContainer.hasClass('is-visible')) {
                            if (themeSettings.header.variant == 'variant-awb') {
                                searchContainer.attr('data-searchbar-state', 'visible');
                            }
                            headerContainerFirst.attr('data-searchbar-state', 'visible');
                            $('header').attr('data-searchbar-state', 'searchbar-visible');
                        }

                        // check on smaller devices if the logo has to be moved - then move back
                        if (window.screen.width <= xxsWidth ) { // Only on the smallest devices
                            logoContainer.removeClass('is-moved'); // custom AWB - makes space for the icons on the right
                        }

                        // hide the the search icon again
                        searchIconContainer.addClass('is-vishidden');

                        // add state to nav-container and header
                        navContainer.attr('data-navbar-state', 'navbar-default');
                        header.attr('data-navbar-state', 'navbar-default');
                    }

                    if(distance >= 200) { // if we scroll more then 200px down
                        // scroll down
                        // first check if the searchresult list - autocomplete is open - don't change state when open
                        if (! autocompleteContainer.hasClass('is-visible')) {
                            if (mediaBreakPointMaxXxs.matches === true ) { // so this only occurs on xxs screens
                                if (themeSettings.header.variant == 'variant-awb') {
                                    searchContainer.attr('data-searchbar-state', 'hidden');
                                }
                                headerContainerFirst.attr('data-searchbar-state', 'hidden');
                                header.attr('data-searchbar-state', 'searchbar-hidden');
                            }
                        }

                        // show the the search icon again
                        searchIconContainer.removeClass('is-vishidden');

                        // check on smaller devices if the logo has to be moved
                        if (window.screen.width <= xxsWidth ) { // Only on the smallest devices
                            logoContainer.addClass('is-moved'); // custom AWB - makes space for the icons on the right
                        }

                        // add state to nav-container
                        if(headerNavAnchors.length == 0 || ! headerNavAnchors.is(':visible')) { // when there's no in-page-nav we like to show the navbar in default state
                            header.attr('data-navbar-state', 'navbar-default');
                        } else {
                            header.attr('data-navbar-state', 'navbar-scroll');
                            navContainer.attr('data-navbar-state', 'navbar-scroll');
                        }
                    }
                });


                searchIconContainer.on('click',function(){
                    // make the searchbar appear again by setting the state
                    if (themeSettings.header.variant == 'variant-awb') {
                        searchContainer.attr('data-searchbar-state', 'visible');
                    }
                    headerContainerFirst.attr('data-searchbar-state', 'visible');
                    header.attr('data-searchbar-state', 'searchbar-visible');
                });


                /**
                 * Nav Anchors HEADER
                 * add header state when the header navanchors have less or more then 3 items in the navanchors in the header
                 * needed for setting the height on the container - and the
                 *
                 * This only occurs on websites which has just a in-page-navigation attached to the header and in no case within the main
                 */
                if (themeSettings.nav_anchors_in_main == false) { // only when there are no nav-anchors in the main section
                    if(headerNavAnchors.length > 0 && navItems.length < 3) {
                        header.attr('data-navanchors-state', 'hidden');
                    }

                    if(headerNavAnchors.length > 0 && navItems.length >= 3) {
                        header.attr('data-navanchors-state', 'visible'); // this should be 'is-visible' but need to find out what impact it has - for now just this comment
                    }

                    // add state when the nav-anchors bar is hidden by css or does not exist for some reason, such as on most homepages
                    // needed for header styling purposes
                    if(headerNavAnchors.length == 0 || ! headerNavAnchors.is(':visible')) {
                        header.attr('data-navanchors-state', 'none');
                    }
                }
            }

            if (typeof themeSettings.header.variant === 'undefined' || themeSettings.header.variant !== 'variant-2') { // then there's no alternative header variant-2 active (so which does not use all the above functionality) and the default is in use
                addStateToHeaderElements();
            }


            function addMainStartPos() {
                const header = $('header');
                const headerheight = header.height();
                const main = $('main');
                const body = $('body');

                if(header.hasClass('variant-1')) {
                    main.css('paddingTop', headerheight + 'px');
                }
            }

            setTimeout(() => {
                addMainStartPos();
            }, 250); // needed to get to know correct heights

        } // end check header exists
    }


    headerFunctions();
});
